import { useState } from "react";
import { ChevronDown } from "lucide-react";

// 4 professional specification designs, shared by admin preview and public product detail.
export const SPEC_DESIGNS = [
  { key: "table", name: "Table Style" },
  { key: "vertical", name: "Vertical Style" },
  { key: "interactive", name: "Interactive" },
  { key: "cards", name: "Card Style" },
];

export function ProductSpecs({ design = "table", specs = {}, compact = false }) {
  const entries = Object.entries(specs || {}).filter(([k]) => k);
  const [open, setOpen] = useState(entries.length ? entries[0][0] : null);
  if (!entries.length) return null;
  const text = compact ? "text-xs" : "text-sm";

  if (design === "vertical") {
    return (
      <div className="grid gap-2.5" data-testid="specs-vertical">
        {entries.map(([k, v]) => (
          <div key={k} className="rounded-lg border border-border bg-card p-3">
            <p className={`font-semibold uppercase tracking-wide text-muted-foreground ${compact ? "text-[10px]" : "text-xs"}`}>{k}</p>
            <p className={`mt-0.5 font-medium ${text}`}>{v}</p>
          </div>
        ))}
      </div>
    );
  }

  if (design === "interactive") {
    return (
      <div className="grid gap-2" data-testid="specs-interactive">
        {entries.map(([k, v]) => {
          const isOpen = open === k;
          return (
            <button type="button" key={k} onClick={() => setOpen(isOpen ? null : k)}
              className="flex flex-col rounded-lg border border-border bg-card p-3 text-left transition-colors hover:border-primary">
              <div className="flex items-center justify-between">
                <span className={`font-display font-bold uppercase tracking-wider ${compact ? "text-xs" : "text-sm"}`}>{k}</span>
                <ChevronDown className={`h-4 w-4 shrink-0 text-primary transition-transform ${isOpen ? "rotate-180" : ""}`} />
              </div>
              {isOpen && <span className={`mt-2 text-muted-foreground ${text}`}>{v}</span>}
            </button>
          );
        })}
      </div>
    );
  }

  if (design === "cards") {
    return (
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3" data-testid="specs-cards">
        {entries.map(([k, v]) => (
          <div key={k} className="rounded-xl border border-border bg-gradient-to-br from-accent/60 to-card p-3.5">
            <p className={`font-semibold uppercase tracking-wide text-primary ${compact ? "text-[10px]" : "text-xs"}`}>{k}</p>
            <p className={`mt-1 font-display font-semibold ${text}`}>{v}</p>
          </div>
        ))}
      </div>
    );
  }

  // table (default)
  return (
    <div className="overflow-hidden rounded-xl border border-border" data-testid="specs-table">
      <table className="w-full">
        <tbody className="divide-y divide-border">
          {entries.map(([k, v], i) => (
            <tr key={k} className={i % 2 ? "bg-secondary/30" : ""}>
              <td className={`w-2/5 px-4 py-2.5 font-medium text-muted-foreground ${text}`}>{k}</td>
              <td className={`px-4 py-2.5 font-medium ${text}`}>{v}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
